import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as productsActions from './list-actions';
import * as routerSelectors from '../../../route/router-state.selectors';
import * as locationSelectors from '../../../locations/state/locations-selectors';
import * as searchSelectors from '../../../products/state/product-search/search-selectors';
import * as categorySelectors from '../../../categories/state/category/categories-selectors';
import * as categoryActions from '../../../categories/state/category/categories-actions';
import * as categoryTreeActions from '../../../categories/state/category-tree/category-tree-actions';

import { ProductService } from "../../_services/product.service";
import { catchError, exhaustMap, map, mergeMap, switchMap, takeUntil, tap, withLatestFrom } from 'rxjs/operators';
import { of } from "rxjs";
import { Store } from "@ngrx/store";
import { _seoContent } from "@app/marketplace/seo-content/utils";
import {ProductProviderEnum} from '@app/marketplace/core/enum/productProvider';
import {environment} from '@env/environment.dev';

@Injectable()
export class ProductsEffects {
  constructor(private actions$: Actions, private service: ProductService, private store: Store<any>,) { }

    loadProducts$ = createEffect(() =>
      this.actions$.pipe(
        ofType(productsActions.LOADING_PRODUCTS, productsActions.CANCEL_PRODUCTS_REQUEST),
          withLatestFrom(
          this.store.select(routerSelectors.getMergedRoute),
          this.store.select(locationSelectors.selectLocation),
          this.store.select(searchSelectors.selectTerm),
          this.store.select(categorySelectors.selectCategoryCode),
          (action: any, router: any, location:any,term:any,category) => {
            if (term.provider == ProductProviderEnum.Shein && !environment.turn_on_shein) {
              term.provider = ProductProviderEnum.Internal;
            }
            return {
              action,
              payload: action.payload,
              params: router.params,
              location:{type:location.locationType,codes:location.locations},
              term: term.provider == 1 && term.searhTerm == '' ? 'Televisores' : term.searhTerm,
              provider: term.provider,
              url: router.url,
              category
            }
          }
        ),
        tap((data: any) => {
          if(data.params["id"]){
            if(data.url.includes('tiendas-asociadas')) {
              data.payload.supplierCode = data.params["id"];
            } else {
              this.store.dispatch(categoryTreeActions.UpdateParentCategory({ parentCategory: this.getCategoryCode(data.params["id"]) }));
            }
            this.store.dispatch(categoryActions.ClearCategoryFilter());
          }
        }),
        switchMap((data: any) => {
        //exhaustMap((data: any) => {
          if(data.action.type==productsActions.LOADING_PRODUCTS){
            data.payload.provider=data.provider;
            data.payload.filter.searchTerms=data.term;
            data.payload.categoryCode = data.category??"";
            data.payload.filter.leafCategories = data.category ? true : null;
            data.payload.locationType = 0;
            data.payload.locations = null;
            //console.info(data.payload);
            const category = !data.url.includes('tiendas-asociadas') ? data.params['id'] : '';
            if (category) {
              const value = _seoContent.find(x => category=== x.sectionId || category === x.categoryCode);
              data.payload.categoryCode = value ? value.categoryCode : category;
              data.payload.filter.leafCategories = true;
            }
            if (data.location.codes.length > 0) {
              data.payload.locationType = data.location.type;
              data.payload.locations = data.location.codes;
            }
          }
          return this.service.ListProducts(data.payload).pipe(
            takeUntil(
              this.actions$.pipe(ofType(productsActions.CANCEL_PRODUCTS_REQUEST))
            ),
            map((response: any) => {
              response.count = response.data.length;
              response.data = response.data.filter(x => x.price > 0);
              var provider=response.count>0?response.data[0].productProvider:0;
              return { type: productsActions.LIST_PRODUCTS, data:response, provider:data.payload.provider,scroll:data.payload.scroll};
            }),
            catchError((error) => {
               return of({ type: productsActions.ERROR_PRODUCTS })
              }
            )
          );
        })
      )
    );

    private getCategoryCode(sectionId: string) {
      return  _seoContent.map(x => ({code: x.categoryCode, name: x.sectionId})).find(x => x.name == sectionId)?.code;
    }
}


